import front from './front';
import back from './back';
import { VUE_APP_BASE_URL } from '@/config/config';

export default {
    mode: 'history',
    base: VUE_APP_BASE_URL,
    linkExactActiveClass: 'active',
    routes: [
        ...front,
        ...back,
        {
            path: '*', hidden: true,
            redirect: to => ({
                name: 'home',
                query: { redirect: to.fullPath }
            })
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
}